import React, { useState, useEffect, Suspense } from 'react';
import PropTypes from 'prop-types';
import { AsyncComponent } from '@zillow/async-component';
import { ErrorBoundary } from 'react-error-boundary';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _isEmpty from 'lodash/isEmpty';
import { csatAnalyticsTracking } from '@zillow/csat-analytics';

var loader = function loader() {
  return import('./CsatOnsiteModalDisplayerHDP-a4a719a4.esm.js');
};

function AsyncCsatOnsiteModalDisplayerHDP(_ref) {
  var shouldWaitForWindowLoad = _ref.shouldWaitForWindowLoad,
      abTests = _ref.abTests,
      csatConfig = _ref.csatConfig;
  return React.createElement(AsyncComponent, {
    loader: loader,
    shouldWaitForWindowLoad: shouldWaitForWindowLoad,
    abTests: abTests,
    csatConfig: csatConfig,
    renderPlaceholder: false
  });
}
AsyncCsatOnsiteModalDisplayerHDP.propTypes = process.env.NODE_ENV !== "production" ? {
  shouldWaitForWindowLoad: PropTypes.bool.isRequired,
  abTests: PropTypes.objectOf(PropTypes.string).isRequired,
  csatConfig: PropTypes.objectOf(PropTypes.object).isRequired
} : {};

var LazyReduxConnectedCsatModal = React.lazy(function () {
  return import('@zillow/csat-redux-provider').then(function (module) {
    return {
      default: module.ReduxConnectedCsatModal
    };
  });
});
var getSurvey = function getSurvey(_ref) {
  return new Promise(function ($return, $error) {
    var csatUrl, displayPage, url, requestConfig, res, survey;
    csatUrl = _ref.csatUrl, displayPage = _ref.displayPage;
    url = csatUrl + "/current?deliveryChannel=onsite&brand=zillow&displayPage=" + displayPage + "&date=" + Date.now();
    requestConfig = {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache,no-store',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    };
    return Promise.resolve(fetch(url, requestConfig)).then(function ($await_2) {
      try {
        res = $await_2;

        if (res.status === 200) {
          return Promise.resolve(res.json()).then(function ($await_3) {
            try {
              survey = $await_3;
              csatAnalyticsTracking(displayPage === 'hdp', [{
                category: 'HDP',
                action: 'generatedCSAT',
                label: survey.surveyToken
              }]);
              return $return(survey);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        }

        return $return({});
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }.bind(this), $error);
  });
};
function CsatOnsiteModalDisplayer(_ref2) {
  var csatUrl = _ref2.csatUrl,
      displayPage = _ref2.displayPage;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      csatSurvey = _useState2[0],
      setCsatSurvey = _useState2[1];
  /*
   isCurrent helps us prevent the following problem -
   Component mounts -> calls fetch -> fetch is pending -> component unmounts ->
   fetch gets resolved and comes back and setState on the unmounted component
   Now with isCurrent the flow would be -
   Component mounts (isCurrent = true) -> calls fetch -> fetch is pending ->
   component unmounts(isCurrent = false)
   -> fetch gets resolved and comes back and does not setState on the unmounted component
   This way we prevent any lingering promise to come back and update state on an unmounted
   component
   */


  useEffect(function () {
    var isCurrent = true;
    getSurvey({
      csatUrl: csatUrl,
      displayPage: displayPage
    }).then(function (survey) {
      if (isCurrent) {
        setCsatSurvey(survey);
      }
    }).catch(function () {
      setCsatSurvey({});
    });
    return function () {
      isCurrent = false;
    };
  }, [csatUrl]);

  if (!_isEmpty(csatSurvey)) {
    return React.createElement(Suspense, {
      fallback: null
    }, React.createElement(LazyReduxConnectedCsatModal, {
      csatData: csatSurvey.survey,
      token: csatSurvey.surveyToken,
      csatUrl: csatUrl,
      displayPage: displayPage
    }));
  }

  return null;
}
CsatOnsiteModalDisplayer.propTypes = process.env.NODE_ENV !== "production" ? {
  csatUrl: PropTypes.string.isRequired,
  displayPage: PropTypes.string.isRequired
} : {};

var CsatOnsiteModalDisplayerHomepage = function CsatOnsiteModalDisplayerHomepage(_ref) {
  var csatUrl = _ref.csatUrl;
  return React.createElement(ErrorBoundary, {
    FallbackComponent: function FallbackComponent() {
      return null;
    }
  }, React.createElement(CsatOnsiteModalDisplayer, {
    csatUrl: csatUrl,
    displayPage: "homepage"
  }));
};

CsatOnsiteModalDisplayerHomepage.propTypes = process.env.NODE_ENV !== "production" ? {
  csatUrl: PropTypes.string.isRequired
} : {};

export { AsyncCsatOnsiteModalDisplayerHDP as A, CsatOnsiteModalDisplayerHomepage as C, CsatOnsiteModalDisplayer as a };
